import { get, put, post } from 'lib/API';
import { OrdersList } from 'data/Order';

export const loadOrders = async (
  [pageSize, page, offset, vendorId, orderId, sortField = null, sortOrder = null, searchTerm = null, countryId = null, showOpen = null, showPendingCancellationEmail = null, brandIds = null, companyId = null, businessUnitId = null, consignmentType = null, affiliateCustomerId = null, commissionStatus = null, consignmentIds = null, affiliateCode = null]: any[],
  { token }: any
): Promise<OrdersList> => {
  let query: any = { pageSize, page, vendorId, orderId };
  const optional = [
    { key: 'sortField', value: sortField },
    { key: 'sortOrder', value: sortOrder },
    { key: 'searchTerm', value: searchTerm },
    { key: 'countryId', value: countryId },
    { key: 'showOpen', value: showOpen },
    { key: 'showPendingCancellationEmail', value: showPendingCancellationEmail },
  ];

  if(vendorId) {
    optional.push({ key: 'brandIds', value: brandIds });
  }

  if(companyId){
    optional.push({ key: 'companyId', value: companyId });
  }

  if(consignmentType){
    optional.push({ key: 'consignmentType', value: consignmentType });
  }

  if (affiliateCustomerId) {
    optional.push({ key: 'affiliateCustomerId', value: affiliateCustomerId });
  }

  if (affiliateCustomerId && commissionStatus) {
    optional.push({ key: 'commissionStatus', value: commissionStatus });
  }

  if (consignmentIds) {
    optional.push({ key: 'consignmentIds', value: consignmentIds });
  }

  if (affiliateCustomerId && affiliateCode) {
    optional.push({ key: 'affiliateCode', value: affiliateCode });
  }

  optional.forEach(param => {
    if (param.value !== null && param.value !== undefined) {
      query[param.key] = param.value;
    }
  });

  return await get('v1/orders', token, query);
};

export const saveOrder = async ([order, dowJones]: any[], { token }: any): Promise<any> => {
  return await put(`v1/orders`, token, {
    order,
    dowJones
  });
};

export const getOrderDetails = async ({ orderId, token }: any): Promise<any> => {
  return await get(`v1/orders/${orderId}`, token);
};

export const cancellationOrderEmailRequest = async ([orderId]: any[], { token }: any): Promise<any> => {
  return await post(`v1/orders/cancellation-email`, token, { orderId });
};